module.exports = __webpack_public_path__ + "static/media/burger.666a2aed.svg";